<script setup lang="ts">
import { fileSave } from 'browser-fs-access';
import { Download } from 'lucide-vue-next';
import { toast } from 'vue-sonner';
import { Button } from '@/components/ui/button';
import useApp from '@/composables/useApp.ts';

const props = withDefaults(
    defineProps<{
        files: string[];
        fileName?: string;
        extensions?: string[];
    }>(),
    {
        fileName: 'Dokumente.zip',
        extensions: ['.zip'],
    }
);

const app = useApp();

function onClick() {
    const promise = () =>
        new Promise(async (resolve, reject) => {
            const data = new FormData();

            for (const file of props.files) {
                data.append('assetUid[]', file);
            }

            const response = await fetch('/api/download', {
                method: 'POST',
                headers: {
                    'X-CSRF-Token': app.csrf.token,
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: data,
            });

            if (response.status !== 200) {
                reject();
                return;
            }

            try {
                await fileSave(response, {
                    fileName: props.fileName,
                    extensions: props.extensions,
                    startIn: 'downloads',
                });

                resolve(void 0);
            } catch (err) {
                if (err.name === 'AbortError') {
                    reject('Download abgebrochen');
                }
            }

            reject('Ein Fehler ist aufgetreten');
        });

    toast.promise(promise, {
        loading: 'Download wird vorbereitet...',
        success: () => 'Dateien heruntergeladen',
        error: (message: string) => message,
    });
}
</script>

<template>
    <Button
        variant="secondary"
        @click.prevent="onClick"
    >
        <Download />
        Alle herunterladen
    </Button>
</template>
